import { jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import * as Headlessui from '@headlessui/react';
import classNames from 'classnames';
import { MenuDivider } from './Menu.Divider/Menu.Divider.es.js';
import { MenuDropdown } from './Menu.Dropdown/Menu.Dropdown.es.js';
import { MenuIcon } from './Menu.Icon/Menu.Icon.es.js';
import { MenuItem } from './Menu.Item/Menu.Item.es.js';
import { MenuLabel } from './Menu.Label/Menu.Label.es.js';
import { MenuOptions } from './Menu.Options/Menu.Options.es.js';

const Menu = ({ theme = 'light', className, variant = 'euclid/default', children })=>{
    // Break variant into mode and name
    const [mode, name] = variant.split('/');
    // Find menu options component
    const menuOptions = useMemo(()=>React__default.Children.toArray(children).find((c)=>/*#__PURE__*/ React__default.isValidElement(c) && c.type === MenuOptions), [
        children
    ]);
    // Make sure menu options exists or throw
    if (menuOptions === undefined) {
        throw new Error('You must have `Menu.Button` and `Menu.Options` as children.');
    }
    // Check for active items inside the menu options
    const activeOptions = useMemo(()=>{
        if (/*#__PURE__*/ React__default.isValidElement(menuOptions)) {
            return React__default.Children.toArray(menuOptions.props.children).filter((c)=>{
                if (/*#__PURE__*/ React__default.isValidElement(c)) {
                    return !c.props.inactive;
                }
                return false;
            });
        }
        return [];
    }, [
        menuOptions
    ]);
    // Check for no active items and hide the menu
    if (activeOptions.length === 0) {
        return null;
    }
    return jsx(Headlessui.Menu, {
        as: "div",
        className: classNames('cb-menu', className, theme, mode, name),
        children: children
    });
};
Menu.displayName = 'Menu';
Menu.Button = Headlessui.Menu.Button;
Menu.Dropdown = MenuDropdown;
Menu.Icon = MenuIcon;
Menu.Options = MenuOptions;
Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Divider = MenuDivider;

export { Menu, Menu as default };
//# sourceMappingURL=Menu.es.js.map
